import {
  React,
  Component,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {CircularProgress} from 'material-ui';

import {StageNotReadyMessage} from 'imports/ComponentsImports';

// StageValidator HOC
const StageValidator = (minOrder, maxOrder) => (WrappedComponent) =>
{
  return withCookies((class WithStageValidator extends Component {
    constructor(props) {
      super(props)
      this.state = {
        token: this.props.cookies.get('token'),
        user: this.props.cookies.get('user'),
        loading: true,
        error: false,
      }
    }

    componentDidMount(){
      this.getCurrentStage()
    }
    render() {
      if(this.state.error){
        return(
          <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
            <p>Error al cargar la etapa en la que se encuentra su empresa. Por favor recarga la página o intenta más tarde.</p>
          </div>
        )
      }
      if(this.state.loading){
        return(
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
              <CircularProgress color='#9e9e9e' size={80} thickness={5} />
            </div>
        )
      }

      let stage = this.state.currentStage.stage;
      if (stage.order > maxOrder) {
        return(<WrappedComponent {...this.props} done={true}/>)
      }
      else if(stage.order < minOrder){
        return(<StageNotReadyMessage stage={stage}/>)
      }
      else {
        return(<WrappedComponent {...this.props}/>)
      }
    }

    getCurrentStage = () => {
      var connection = axios.create({
        baseURL: routes.host,
        headers: {'Authorization': "Token "+ this.state.token}
      });
      connection.get(routes.getCurrentStage(this.state.user.company_id))
      .then((response) => {
        this.props.cookies.set('current_stage', JSON.stringify(response.data[response.data.length - 1]), { path: '/' });
        this.setState({
          loading: false,
          error: false,
          currentStage: response.data[response.data.length - 1],
        })
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: true,
        });
        console.error(error);
      })
    }
  }))
}

export default StageValidator;



// WEBPACK FOOTER //
// ./src/components/common/StageValidator.js